export default __webpack_public_path__ + "static/media/c002-PPII-1.de8db848.svg";